import React from "react";

export const CargandoSpinner = () => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(238, 231, 231, 0.65)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
      }}
    >
      <div className="d-flex align-items-center bg-white px-4 py-3 rounded shadow">
        <div className="spinner-border text-info" role="status">
          <span className="sr-only">Cargando...</span>
        </div>
        <span className="text-info animate-flicker ml-3">
          <b>Cargando</b>
        </span>
      </div>
    </div>
  );
};
	